import { useEffect } from 'react';

import AOS from 'aos';

// routes
import Routes from './routes/Routes';

// components
import AlertContainer from './components/AlertContainer';
import { NotificationProvider } from './contexts/NotificationContext';
import { CurrencyProvider } from './contexts/CurrencyContext';

// Redux
import { useAppDispatch, useAppSelector } from './app/hooks';
import { refreshCurrentUser } from './features/login/loginSlice';

// Themes
// For Default import Theme.scss
import './assets/styles/scss/theme.scss';

// Debounce ResizeObserver to prevent errors
if (typeof window !== 'undefined') {
    const debounce = (fn: Function, delay: number) => {
        let timeoutId: NodeJS.Timeout;
        return (...args: any[]) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => fn(...args), delay);
        };
    };

    const originalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class extends originalResizeObserver {
        constructor(callback: ResizeObserverCallback) {
            const debouncedCallback = debounce(callback, 20);
            super(debouncedCallback);
        }
    };
}

const App = () => {
    const dispatch = useAppDispatch();
    const { token, user } = useAppSelector((state) => state.auth);

    useEffect(() => {
        // Init animations
        AOS.init();
    }, []);

    // Refresh user permissions on app load if logged in
    useEffect(() => {
        if (token && user) {
            // Check if user has permissions field - if not, refresh from server
            if (!user.permissions || user.permissions.length === 0) {
                console.log('Refreshing user permissions...');
                dispatch(refreshCurrentUser());
            }
        }
    }, [token, user, dispatch]);

    return (
        <CurrencyProvider>
            <NotificationProvider>
                <Routes />
                <AlertContainer />
            </NotificationProvider>
        </CurrencyProvider>
    );
};

export default App;
